// check if breadcrumbs are valid, validation for PBS and PPW is different
import { breadcrumbsLevels, BreadcrumbTypes, PageNames } from './constants';
import { TBreadcrumbs } from './types/breadcrumbs';

export const areBreadcrumbsLevelsValid = (
  breadcrumbs: TBreadcrumbs[],
  key:string,
  breadcrumbsType:BreadcrumbTypes,
):boolean => {
  if (!breadcrumbs?.length) {
    return false;
  }

  const currentPageType = key?.split('/')[0] as PageNames;
  const breadcrumbsTypes = breadcrumbsLevels[breadcrumbsType];

  const endIndex = breadcrumbsTypes.indexOf(currentPageType);

  const updatedBreadcrumb = breadcrumbsTypes.slice(0, endIndex || 1);

  return updatedBreadcrumb.every((breadcrumbType, breadcrumbTypeIndex) => {
    return (
      breadcrumbs[breadcrumbTypeIndex]
        && breadcrumbs[breadcrumbTypeIndex].itemType === breadcrumbType
    );
  });
};

// When breadcrumbs item is pressed, function finds an index of this,
//  cut breadcrumbs after that item and return updated breadcrumb
export const filterBreadcrumbsForSaving = (arr:TBreadcrumbs[], itemType):TBreadcrumbs[] => {
  const index = arr.findIndex((obj) => obj.itemType === itemType);
  return index !== -1 ? arr.slice(0, index + 1) : [];
};
